import Model from './Model'

export default class Reseller extends Model {

	/** @type int */ id
	/** @type string */ display_name
	/** @type string */ email
	/** @type string */ support_phone_number
	/** @type bool */ show_invoices
	/** @type bool */ has_payment_processor
	/**
	 * Contains the complete URLs for the different logo sizes
	 * @type {?{'1x': string, '2x': ?string}}
	 */ logo
	/** @type ResellerStyle */ style

	constructor(props) {
		super(props)
		this.style = new ResellerStyle(props)
	}
}

// eslint-disable-next-line no-unused-vars
class ResellerStyle {
	/** @type string */ primary
	/** @type string */ secondary
	/** @type string */ logo

	static get DEFAULT_PRIMARY() { return '#2B0804' }
	static get DEFAULT_SECONDARY() { return '#4C1207' }

	constructor(props) {
		if (!props) {
			return
		}

		if (props.colors) {
			this.primary   = props.colors.primary || ResellerStyle.DEFAULT_PRIMARY
			this.secondary = props.colors.secondary || ResellerStyle.DEFAULT_SECONDARY
		}

		if (props.logo) {
			this.logo = props.logo
		}
	}
}
